// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { qrcodeRead } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-qrcode-read': IconQrcodeRead;
    }
}

/**
 * The icon component for the 'qrcodeRead' icon
 */
export class IconQrcodeRead extends IconSvg {
    public constructor() {
        super(qrcodeRead);
    }
}

registerIconSvg('icon-qrcode-read', IconQrcodeRead);
export const iconQrcodeReadTag = 'nimble-icon-qrcode-read';
